const v = "4.8.0";
const meta = {
  g: "LottieFiles AE ",
  a: "",
  k: "",
  d: "",
  tc: ""
};
const fr = 29.9700012207031;
const ip = 0;
const op = 15.0000006109625;
const w = 80;
const h = 80;
const nm = "outro_wrong_eff";
const ddd = 0;
const assets = [];
const layers = [
  {
    ddd: 0,
    ind: 1,
    ty: 4,
    nm: "모양 레이어 5",
    sr: 1,
    ks: {
      o: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833
              ],
              y: [
                0.833
              ]
            },
            o: {
              x: [
                0.167
              ],
              y: [
                0.167
              ]
            },
            t: 8,
            s: [
              100
            ]
          },
          {
            t: 15.0000006109625,
            s: [
              0
            ]
          }
        ],
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          40,
          40.882,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          0,
          0,
          0
        ],
        ix: 1
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.092,
                0.092,
                0.667
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 0,
            s: [
              16,
              16,
              100
            ]
          },
          {
            t: 15.0000006109625,
            s: [
              35,
              35,
              100
            ]
          }
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    62.13,
                    -64.649
                  ],
                  [
                    -62.13,
                    59.611
                  ]
                ],
                c: false
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                1,
                1,
                1,
                1
              ],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 30.125,
              ix: 5
            },
            lc: 1,
            lj: 1,
            ml: 4,
            bm: 0,
            nm: "선 1",
            mn: "ADBE Vector Graphic - Stroke",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                -100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "모양 2",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      },
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    62.13,
                    -64.649
                  ],
                  [
                    -62.13,
                    59.611
                  ]
                ],
                c: false
              },
              ix: 2
            },
            nm: "패스 1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                1,
                1,
                1,
                1
              ],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 30.125,
              ix: 5
            },
            lc: 1,
            lj: 1,
            ml: 4,
            bm: 0,
            nm: "선 1",
            mn: "ADBE Vector Graphic - Stroke",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "모양 1",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 2,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 0,
    op: 15.0000006109625,
    st: -26.0000010590017,
    bm: 0
  }
];
const markers = [];
const wrongAnimation = {
  v,
  meta,
  fr,
  ip,
  op,
  w,
  h,
  nm,
  ddd,
  assets,
  layers,
  markers
};
export {
  assets,
  ddd,
  wrongAnimation as default,
  fr,
  h,
  ip,
  layers,
  markers,
  meta,
  nm,
  op,
  v,
  w
};
//# sourceMappingURL=toon_outro_wrong.json.js.map
